/**
 * # Components
 *
 * UI-Router React Components and their APIs:
 * - [[UIRouter]]: Main router component
 * - [[UIView]]: A viewport for routed components
 * - [[UISref]]: A state ref to a target state; navigates when clicked
 * - [[UISrefActive]]: Adds a css class when a UISref's target state (or a child state) is active
 *
 * @preferred
 * @reactapi
 * @module components
 */ /** */
export * from './UIRouter';
export * from './UIView';
export * from './UISref';
export * from './UISrefActive';
//# sourceMappingURL=components.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@uirouter/react/lib-esm/components/components.js
// module id = 473
// module chunks = 0